export const DatePopupMixin = (getElement = function() { return this.$refs.popup }) => ({
    data() {
        return {
            arrowStyle: {}
        }
    },
    watch: {
        async isOpened() {
            if (this.isOpened) {
                if (!this.inputValue) {
                    let date = new Date(this.date);
                    date.setDate(date.getDate() + 2);
                    this.setDate(date);
                }
                await this.$nextTick();
                const el = getElement.call(this);
                const { y, height } = el.getBoundingClientRect();
                if (el && y + height + 20 > window.innerHeight) {
                    el.style.top = 'initial';
                    el.style.bottom = '60px';
                    const gap = this.$options.name === 'DatePicker' ? -5: -20;
                    this.arrowStyle = {
                        top: height + gap + 'px',
                        color: 'black',
                        transform: 'rotateX(180deg)'
                    };
                }
            }
        }
    },
});


// WEBPACK FOOTER //
// ./src/mixins/DatePopupMixin.js